import {Component, Input} from '@angular/core';
import {TooltipModule} from 'primeng/tooltip';

@Component({
  selector: 'em-coverage-card',
  templateUrl: './coverage-card.component.html',
  imports: [TooltipModule],
})
export class CoverageCardComponent {
  @Input() tooltipText: string | undefined;
  @Input() title: string | undefined;
  @Input() subtitle: string | undefined;
  @Input() note: string | undefined;
}
